const getDawaIdFromkvhxUrl = (kvhxUrl: string): string => {
    return kvhxUrl.split('/').pop() ?? '';
};

export { getDawaIdFromkvhxUrl };
